import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { lowLqiSignalThreshold } from '@common';
import { NO_VALUE } from '@pipes';
import { GatewayDevice, InstallationFeaturesStore } from '@store';
import {
  DeviceConnectionStatus,
  Feature,
  FeatureNames,
  FeaturePropertyKey,
  SignalProperties,
} from '@vi-iot/client';
import { Observable } from 'rxjs';
import { FeatureTileIconVariant } from '../../../../shared/components/feature-tile/feature-tile-variants';
import { InstallationService } from '../../../services/installation.service';

@Component({
  selector: 'app-repeaters-wifi-lqi',
  templateUrl: './repeaters-wifi-lqi.component.html',
  styleUrls: ['./repeaters-wifi-lqi.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RepeatersWifiLqiComponent implements OnInit {
  readonly featurePropertyKey = FeaturePropertyKey;
  @Input() device: GatewayDevice;

  wifiLqi$: Observable<Feature<SignalProperties, never>>;
  status$: Observable<Feature<DeviceConnectionStatus, never>>;
  readonly noValue = NO_VALUE;
  readonly lowLqiSignalThreshold = lowLqiSignalThreshold;
  readonly iconVariant = FeatureTileIconVariant;

  constructor(
    public installationService: InstallationService,
    private installationFeaturesStore: InstallationFeaturesStore
  ) {}

  ngOnInit(): void {
    this.wifiLqi$ = this.installationFeaturesStore.selectInstallationDeviceFeature(
      FeatureNames.deviceZigbeeLqi,
      this.device.id
    );

    this.status$ = this.installationFeaturesStore.selectInstallationDeviceFeature(
      FeatureNames.deviceConnection,
      this.device.id
    );
  }
}
